<template>
  <Card shadow>
    <!--  <Breadcrumb>-->
    <!--    <BreadcrumbItem>开发票</BreadcrumbItem>-->
    <!--  </Breadcrumb>-->

    <div class="invoice-wrap">
      <Row class="row-margin">
        <Col span="2">
          <h3>发票抬头</h3>
        </Col>
      </Row>
      <Row class="row-margin">
        <Col span="8">
          <Button
            class="tab-btn"
            @click="checkType('personal')"
            v-if="tabShow"
            :type="btnType('personal')"
            >个人</Button
          >
          <Button
            class="tab-btn"
            @click="checkType('company')"
            :type="btnType('company')"
            >单位</Button
          >
        </Col>
      </Row>
      <Row class="row-margin" v-if="btnOn === 1">
        <Col span="8">
          <Form
            ref="formInline"
            :model="formInline"
            :rules="ruleInline"
            inline
            :label-width="120"
          >
            <FormItem label="发票抬头" prop="companyName">
              <Select v-model="formInline.id" style="width: 180px">
                <Option
                  v-for="item in invoiceList"
                  :value="item.id"
                  :key="item.id"
                  >{{ item.companyName }}</Option
                >
              </Select>
              <!--          <Input type="text" v-model="formInline.companyName" placeholder="请输入单位名称"></Input>-->
            </FormItem>
          </Form>
        </Col>
        <Col span="8">
          <Button class="tab-btn" @click="createInvoiceTitle" type="primary"
            >创建发票抬头</Button
          >
        </Col>
      </Row>
      <Row class="row-margin" v-if="btnOn === 0">
      <Col span="8">
        <Form ref="formInline" :model="formInline" :rules="ruleInline" inline :label-width="120">
          <FormItem label="发票抬头" prop="companyName">
              <Input type="text" v-model="formInline.companyName" placeholder="请输入发票抬头"></Input>
          </FormItem>
        </Form>
      </Col>
    </Row>
      <Row class="row-margin">
        <Col span="2">
          <h3>开票订单</h3>
        </Col>
      </Row>
      <Table
        :columns="columns2"
        :data="data2"
        @on-select="selectTable"
        @on-select-cancel="selectTableCancel"
        @on-select-all="selectTableAll"
        @on-select-all-cancel="selectTableAllCancel"
        :loading="Loading"
      >
      </Table>
      <Row style="margin-top: 24px;">
        <Col span="12">
          <div class="total-wrap">
            <span>开票金额</span>
            <span class="total-price">{{ totalPrice }}</span>
            <span>元</span>
          </div>
        </Col>
        <Col span="12">
          <Button
            type="primary"
            class="next-btn"
            @click="handleSubmit('formInline')"
            >确定开票</Button
          >
        </Col>
      </Row>
      <div class="space">
        <h3 style="margin-bottom: 10px;">温馨提示</h3>
        <p v-for="(item, index) in noticeList">{{ index + 1 }}、{{ item }}</p>
      </div>
    </div>
  </Card>
</template>

<script>
import { httpAction } from "@/api/manage";
import api from "@/api";
import common from "@/util/common";
export default {
  name: "create-invoice",
  data() {
    const validateFun = (rule, value, callback) => {
      if (!value) {
        let errorStr = "";
        if (rule.field === "companyName") {
          errorStr = "请填写单位名称";
        } else if (rule.field === "id") {
          errorStr = "请选择发票抬头";
        }
        return callback(new Error(errorStr));
      } else {
        return callback();
      }
    };
    return {
      formInline: {
        companyName: "",
        id: ""
      },
      ruleInline: {
        companyName: [{ validator: validateFun, trigger: "blur" }],
        id: [{ validator: validateFun, trigger: "blur" }]
      },
      columns2: [
        {
          type: "selection",
          width: 60,
          align: "center"
        },
        {
          title: "订单编号",
          key: "orderSn",
          minWidth: 100
        },
        {
          title: "游玩日期",
          key: "playDate"
        },
        {
          title: "订单状态",
          key: "statusName"
        },
        {
          title: "金额",
          key: "availableAmount"
        },
        {
          title: "创建时间",
          key: "createTime",
          minWidth: 120
        }
      ],
      invoiceList: [],
      data2: [],
      // url: {
      //   list: '/yhy/openapi/web/invoice/list',
      //   orderList: '/yhy/openapi/web/invoice/available/order/list',
      //   createInvoice: '/yhy/openapi/web/invoice/apply',
      //   getNotice: '/yhy/openapi/web/invoice/notice'
      // },
      actionType: "",
      listLoading: false,
      Loading: false,
      deleteShow: false,
      currentItem: {},
      modal_loading: false,
      pageInfo: {
        totalCount: 0
      },
      pageNum: 1,
      showMore: true,
      btnOn: 0,
      selectOn: [],
      tabShow: true,
      noticeList: []
    };
  },
  computed: {
    totalPrice() {
      let price = 0;
      this.selectOn.forEach(item => {
        price += item.availableAmount * 1;
      });
      return price.toFixed(2);
    }
  },
   async mounted () {
    await this.getList()
    await this.getOrderList()
    await this.getNotice()
    // this.getHistory()
    if (common.userType() === "1") {
      this.btnOn = 1;
      this.tabShow = false;
    }
  },
  methods: {
    getNotice() {
      httpAction(api.getInvoiceNotice, "post").then(res => {
        if (res.status == 0) {
          this.noticeList = res.data;
        }
      });
    },
    createInvoiceTitle() {
      this.$router.push("/order/invoice");
    },
    getList() {
      httpAction(api.invoiceList, "post").then(res => {
        if (res.status == 0) {
          this.invoiceList = res.data;
          let existDefault = false;
          // console.log(this.invoiceList)
          res.data.forEach(item => {
            if (item.isDefault == 1) {
              existDefault = true;
              this.formInline.companyName = item.companyName;
              this.formInline.id = item.id;
            }
          });

          if (this.invoiceList && !existDefault) {
            this.formInline.companyName = this.invoiceList[0].companyName;
            this.formInline.id = this.invoiceList[0].id;
          }
          if (common.userType() !== '1') {
            this.formInline.companyName = '个人'
          }
        }
      });
    },
    handleSubmit(name) {
      if (this.selectOn.length < 1) {
        this.$Message.warning("请选择要开票的订单!");
        return false;
      }

      let obj = {
        //orderType: common.userTypeStr(), // INDI 散客    GROUP 团体
        invoiceType: "2",
        invoiceHeader: this.btnOn === 0 ? "person" : "company",
        companyName: "",
        taxId: "",
        orderIdList: this.selectOn.map(item => item.orderId)
      };
      if (this.btnOn === 1) {
        this.$refs[name].validate(valid => {
          if (valid) {
            // obj.taxId = this.formInline.taxId;
            for (const invoice of this.invoiceList) {
              const invoiceId = this.formInline.id
              if(invoice.id == invoiceId){
                obj.taxId = invoice.taxId
                obj.companyName = invoice.companyName;
                break;
              }
            }
            this.createInvoice(obj);
          }
        });
      } else {
        obj.companyName = this.formInline.companyName
        this.createInvoice(obj);
      }
    },
    selectTable(selection, row) {
      this.selectOn = selection;
    },
    selectTableCancel(selection, row) {
      this.selectOn = selection;
    },
    selectTableAll(selection) {
      this.selectOn = selection;
    },
    selectTableAllCancel(selection) {
      this.selectOn = selection;
    },
    btnType(type) {
      let btnType = null;
      if (type === "personal") {
        if (this.btnOn === 0) btnType = "primary";
      } else {
        if (this.btnOn === 1) btnType = "primary";
      }

      return btnType;
    },
    checkType(type) {
      if (common.userType() === "1") {
        this.btnOn = 1;
      } else {
        if (type === "personal") {
          this.btnOn = 0;
        } else {
          this.btnOn = 1;
        }
      }
    },
    createInvoice(obj) {
      this.$Modal.confirm({
        title: "发票",
        content: "确定要开具发票吗?",
        onOk: () => {
          httpAction(
            this.common.isGroup()
              ? api.groupApplyInvoice
              : api.indiApplyInvoice,
            "post",
            obj
          ).then(res => {
            if (res.status === "0") {
              // this.$Message.success('开票申请提交成功，请耐心等待')
              this.$router.push("/order/invoice-end");
            } else {
              this.$Message.warning("开票申请提交失败");
            }
            // this.data2 = res.data
            // this.Loading = false
          });
        }
      });
    },
    toDownload(params) {
      let pdfUrl = params.row.pdfUrl;
      window.open(pdfUrl);
    },
    getOrderList() {
      this.Loading = true;
      const obj = {};
      httpAction(
        this.common.isGroup()
          ? api.groupInvoiceOrderList
          : api.indiInvoiceOrderList,
        "post",
        obj
      ).then(res => {
        this.data2 = res.data;
        this.Loading = false;
      });
    },
    pageChange() {
      this.getHistory();
    },
    getHistory() {
      const pageNum = this.pageNum;
      const obj = {
        orderType: "GROUP",
        pageNo: pageNum,
        perPageSize: 5
      };
      this.historyLoading = true;
      httpAction(this.url.history, "post", obj).then(res => {
        this.data2.push(...res.data.infoList);
        this.pageInfo.totalCount = res.data.totalCount * 1;
        this.historyLoading = false;
        if (res.data.infoList.length < 5) {
          this.showMore = false;
        } else {
          this.pageNum += 1;
        }
      });
    },
    toEdit(params) {
      this.actionType = "update";
      this.$set(this.data1[params.index], "editable", true);
    },
    edit(params) {
      const data = params.row;
      const obj = {
        companyName: data.companyName,
        taxId: data.taxId,
        isDefault: data.isDefault
      };
      if (this.actionType === "update") {
        obj.invoiceId = data.id;
      }
      httpAction(this.url[this.actionType], "post", obj).then(res => {
        if (res) {
          this.getList();
        }
      });
    },
    add() {
      this.actionType = "create";
      this.data1.push({
        companyName: "",
        taxId: "",
        isDefault: 0,
        editable: true
      });
    },
    remove() {
      this.modal_loading = true;
      const data = this.currentItem.row;
      const obj = {
        invoiceId: data.id
      };
      httpAction(this.url.delete, "post", obj).then(res => {
        if (res) {
          this.cancel();
          this.modal_loading = false;
          this.getList();
        }
      });
    },
    cancel() {
      this.deleteShow = false;
    }
  }
};
</script>

<style scoped lang="less">
.header-title-Invoice {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
}
.invoice-wrap {
}
.space {
  padding: 10px;
  color: @space;
}
.tab-btn {
  padding: 0 20px;
  margin-left: 20px;
}
.row-margin {
  margin-bottom: 20px;
}
.total-wrap {
  line-height: 40px;
  display: flex;
  flex-direction: row;
  font-weight: 600;
  font-size: 18px;
  align-items: baseline;
}
.total-price {
  font-size: 36px;
  /*color: #c94646;*/
  margin-left: 24px;
}
.show-more-btn {
  display: block;
  margin: 20px auto 0;
  box-shadow: none;
}
.next-btn {
  padding: 0 120px;
  height: 40px;
  margin-bottom: 20px;
}
</style>
